<template>
  <interview-layout :touch-and-validate="touchAndValidate">
    <!-- inner wrapper used for centering -->
    <div class="" style="max-width: 440px;">
      <!-- title above form card -->
      <h1 class="px-4 text-primary fade-in-up-enter-active animation-slowest">Hoe wilt u verduurzamen?</h1>
      <!-- <h4 class="px-4 pb-3 fade-in-up-enter-active animation-slowest delay-200">Een beter huis, op uw manier.</h4> -->
      <div class="d-flex flex-column flex-lg-row justify-content-center">

        <!-- form 1 card -->
        <base-card class="w-100" color="alternate" :outer-padding="true" :stretch-inner="true" inner-class="vw-100">
          <base-form @submit="onSubmit">

            <!-- Op welke termijn zou u de maatregelen willen uitvoeren? -->
            <base-input
              type="radiobuttons"
              :options="termijnOptions"
              text-align="left"
              direction="column"
              name="Termijn"
              v-model:value="lead.intentions.Termijn"
              :validator="v$.intentions.Termijn"
              >
                Op welke termijn wilt u verduurzamen?
              </base-input>

              <!-- Hoe wilt u de stappen uitvoeren? -->
              <base-input
              type="radiobuttons"
              :options="aanpakOptions"
              text-align="left"
              direction="column"
              name="Aanpak"
              v-model:value="lead.intentions.Aanpak"
              :validator="v$.intentions.Aanpak"
              >
                Hoe zou u de plannen willen uitvoeren?
              </base-input>
            
          </base-form>
        <!-- form card end -->
        </base-card>

        <!-- form 2 card -->
        <Transition name="fade-in-up">
          <base-card class="pt-2" inner-class="container-meager fade-in-up-enter-active animation-slowest" color="alternate" :outer-padding="true" v-show="showHoaContactForm">
            <base-form @submit="onSubmit">
              <div class="section-hoa-contact pt-3">

                <h5>Contactgegevens vertegenwoordiger VVE</h5>

                <base-input name="HoaRepName"
                  v-model:value="lead.ownership.HoaRepName" :validator="v$.ownership.HoaRepName">
                  Volledige naam
                </base-input>

                <base-input name="HoaRepPhone" placeholder="+316 00 00 00 00"
                  v-model:value="lead.ownership.HoaRepPhone" type="phone" :validator="v$.ownership.HoaRepPhone">
                  Telefoonnummer
                </base-input>

                <base-input name="HoaRepEmail" placeholder="test@example.com" 
                  v-model:value="lead.ownership.HoaRepEmail" :validator="v$.ownership.HoaRepEmail" :debounce="700" :debounce-touch-only="true">
                  E-mailadres
                </base-input>

              </div>
            </base-form>
          </base-card>
        </Transition>
      
      <!-- cards wrapper end -->
      </div>
      <button-row class="mt-2 flex-row-reverse">
        <base-button class="ms-auto" icon="bi-arrow-right" @click="onSubmit" :disabled="v$.ownership.$invalid">Volgende</base-button>
        <base-button variant="minimal-secondary" icon="bi-arrow-left" icon-position="start" @click="onPrev">Terug</base-button>
      </button-row>
      <!-- inner wrapper end -->
    </div>
  </interview-layout>
</template>

<script>
  import InterviewLayout from "@/views/layouts/InterviewLayout.vue"
  import BaseCard from '@/components/BaseCard.vue'
  import BaseForm from "@/components/BaseForm.vue"
  import BaseInput from "@/components/BaseInput.vue"
  import BaseButton from "@/components/BaseButton.vue"
  import ButtonRow from "@/components/ButtonRow.vue"

  import { useAllStores } from "@/helpers/UseAllStores"
  import { CommonComposable } from "@/helpers/CommonComposable"
  import { FlowService } from "@/services/FlowService"

  export default {
    components: {
      InterviewLayout,
      BaseCard,
      BaseForm,
      BaseInput,
      BaseButton,
      ButtonRow
    },
    setup(props, context) {
      return { ...CommonComposable(props, context), ...useAllStores() };
    },
    data() {
      return {
        yesNo: [
          {
            label: 'Ja',
            value: true
          },
          {
            label: 'Nee',
            value: false
          },
        ],
        termijnOptions: [
          {
            label: 'Zo snel mogelijk',
            value: 'Zo snel mogelijk'
          },
          {
            label: 'Binnen een half jaar',
            value: 'Binnen een half jaar'
          },
          {
            label: 'Later',
            value: 'Later'
          }
        ],
        aanpakOptions: [
          {
            label: 'Alles in één keer uitvoeren',
            value: 'Alles in één keer'
          },
          {
            label: 'Stapsgewijs over langere tijd',
            value: 'Stapsgewijs over langere tijd'
          }
        ]
      };
    },
    computed: {
      showHoaContactForm() {
        return (this.lead.ownership.HoaPermission == true && this.lead.ownership.HoaMember == true);
      }
    },
    methods: {
      touchAndValidate() {
        this.v$.ownership.$touch();
        return !this.v$.ownership.$invalid;
      },
      onSubmit() {
        if (this.touchAndValidate()) {
          FlowService.pushNext(this);
        }
      },
      onPrev() {
        FlowService.pushPrev(this);
      }
    }
  }
</script>

<style lang="scss">
</style>